import { Component, OnInit, Input } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'sun-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {

  @Input() title: string;

  opened: boolean;

  constructor(
    private location: Location,
    private router: Router,
  ) { }

  ngOnInit() {
    this.opened = false;
  }

  back() {
    this.location.back();
  }

  toggleMenu() {
    this.opened = !this.opened;
  }
}




// WEBPACK FOOTER //
// ./src/app/component/header/header.component.ts